import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useTranslation } from 'react-i18next';
import LOGO from '../assets/memowrite_logo.svg';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const LOCALES = {
  'en-US': { title: '🇺🇸 English US' },
  'en-GB': { title: '🇬🇧 English UK / Int' },
  'es-ES': { title: '🇪🇦 Español' },
  'es-MX': { title: '🇲🇽 Español MX / US' },
  'fr-FR': { title: '🇫🇷 Francais' },
  'fr-CA': { title: '🇨🇦 Francais CA' },
  de: { title: '🇩🇪 Deutsch' },
  it: { title: '🇮🇹 Italiano' },
};

const NavigationLogin = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const lang = queryParams.get('lang');

    let newLanguage = 'en-US';

    if (lang === 'es') {
      newLanguage = 'es-ES';
    } else if (lang === 'fr') {
      newLanguage = 'fr-FR';
    } else if (lang === 'de') {
      newLanguage = 'de';
    } else if (lang === 'it') {
      newLanguage = 'it';
    }

    i18n.changeLanguage(newLanguage);
  }, [location.search]);

  const handleChangeLanguage = async (language) => {
    i18n.changeLanguage(language);
  };

  return (
    <Navbar collapseOnSelect expand="lg">
      <Container>
        <Navbar.Brand href="/">
          <img src={LOGO} alt="memowrite logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <NavDropdown
          title={LOCALES[i18n?.language || 'en']?.title}
          id="basic-nav-dropdown"
          className="mt-2 bg-white rounded-pill px-3 py-2"
        >
          {Object.keys(LOCALES).map((locale) => (
            <NavDropdown.Item
              className="rounded px-3 py-2"
              key={LOCALES[locale]?.title}
              onClick={() => handleChangeLanguage(locale)}
            >
              {LOCALES[locale]?.title}
            </NavDropdown.Item>
          ))}
        </NavDropdown>
      </Container>
    </Navbar>
  );
};

export default NavigationLogin;
